import { render } from "./billing.vue?vue&type=template&id=738b5152&scoped=true&ts=true"
import script from "./billing.vue?vue&type=script&lang=ts"
export * from "./billing.vue?vue&type=script&lang=ts"

import "./billing.vue?vue&type=style&index=0&id=738b5152&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-738b5152"]])

export default __exports__